<template>
  <div class="tabs">
    <div class="tabs-content w1200">
      <ul class="tabs-list">
        <li class="tabs-item" @click="enterClick(1)">
          <i class="icon icon1"></i>
          <span>证书查询</span>
        </li>
        <li class="tabs-item" @click="enterClick(2)">
          <i class="icon icon2"></i>
          <span>会员登录</span>
        </li>
        <!-- <li class="tabs-item" @click="enterClick(3)">
          <i class="icon icon3"></i>
          <span>协会简介</span>
        </li> -->
      </ul>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
export default {
  name: 'tabs',
  components: {
    Cookies
  },
  data () {
    return {

    }
  },
  methods: {
    enterClick (num) {
      if (num === 1) {
        this.$router.push({
          name: `PersonalCertificate`
        })
      } else if (num === 2) {
        if (localStorage.getItem('assoUserInfo') && localStorage.getItem('assoUserInfo') !== null) {
          window.open('/#/PersonInfo/', '_memberCenter')
        } else {
          window.open('/#/Login/', '_memberCenter')
        }
        // if (Cookies.get('assoUserInfo') && Cookies.get('assoUserInfo') !== null) {
        //   window.open('/#/PersonInfo/', '_memberCenter')
        // } else {
        //   window.open('/#/Login/', '_memberCenter')
        // }
      } else if (num === 3) {
        this.$router.push({
          name: `AboutAsso`
        })
      }
    }
  },
  mounted () {

  },
  created () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .tabs{
    width: 100%;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.15);
    /* background-color: #dfeaf7; */
  }
  .tabs-content{
    padding: 20px 0px;
    overflow: hidden;

  }
  .tabs-list{
    width: 100%;
    overflow: hidden;
    display:flex;
    justify-content: space-around;
  }
  .tabs-item{
    text-align: center;
    /* width: 50%; */
    /* float: left; */
  }
  .tabs-item:hover{
    cursor: pointer
  }
  .tabs-item .icon{
    width: 36px;
    height: 36px;
    margin: 0px auto;
    display:block;
    background-position: 0px 0px;
    background-repeat: no-repeat;
    background-size: 36px 36px;
  }
  .tabs-item span{
    font-size:22px;
    color:#1e1e1e;
    margin-top: 10px;
    display: inline-block;
    font-weight: bold;
  }
  .tabs-item .icon1{
    background-image: url(../../../../static/images/zhengshu_icon.png);
  }
  .tabs-item .icon2{
    background-image: url(../../../../static/images/huiyuan_icon.png);
  }
  .tabs-item .icon3{
    background-image: url(../../../../static/images/xiehuijianjie_icon.png);
  }

</style>



// WEBPACK FOOTER //
// src/components/common/Tabs/Tabs.vue